import Component from '@glimmer/component'
import type { TOC } from '@ember/component/template-only'
import { service } from '@ember/service'
import type { SubscriptionTypeService } from 'teacher-ui-client/services/subscription-type'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface DropdownButtonSignature {
  Element: HTMLButtonElement
  Args: {
    disabled?: boolean
  }
  Blocks: { default: [] }
}

export class ThemedDropdownButton extends Component<DropdownButtonSignature> {
  @service subscriptionType!: SubscriptionTypeService

  get outlineClassNames() {
    switch (this.subscriptionType.current) {
      case SubscriptionType.Reading:
        return 'focus:outline-oceany-blue-300/75 open:outline-oceany-blue-300/75'
      case SubscriptionType.Maths:
        return 'focus:outline-ms-green-300/75 open:outline-ms-green-300/75'
      case SubscriptionType.Writing:
        return 'focus:outline-wl-blue-300/75 open:outline-ml-blue-300/[0.75]'
    }
  }

  <template>
    <button
      type="button"
      class="border-dusty-black-100 text-dusty-black-300 hover:bg-dusty-black-50 focus:bg-dusty-black-50 disabled:border-dusty-black-100 disabled:bg-dusty-black-50 disabled:text-dusty-black-200 inline-flex w-full items-center justify-between rounded-md border bg-white p-2 align-middle outline outline-2 outline-transparent transition-all duration-200 select-none disabled:pointer-events-none disabled:cursor-default
        {{this.outlineClassNames}}"
      ...attributes
      {{! After splattributes forces use of @disabled for disabling, to keep consistent usage }}
      disabled={{@disabled}}
    >
      {{yield}}
    </button>
  </template>
}

interface DropdownContentSignature {
  Element: HTMLDivElement
  Args: {
    /**
     * Likely want to constrain the width in most cases, except when dropdown is configured to match trigger width.
     */
    constrainWidth?: boolean
  }
  Blocks: { default: [] }
}

/**
 * Provides a container with round corners and shadow
 */
export const ThemedDropdownContent: TOC<DropdownContentSignature> = <template>
  <div
    class="shadow-dropdown border-neutral-75 mt-1 overflow-hidden rounded-lg border-2 bg-white
      {{if @constrainWidth 'max-w-96 min-w-48'}}"
    ...attributes
  >
    {{yield}}
  </div>
</template>
